module.exports = __webpack_public_path__ + "img/icon_code_1.d651d5da.webp";